import { FormControl, FormLabel, Autocomplete, TextField, Typography } from '@mui/material';
import { Controller } from "react-hook-form";

export default function MultiDropdown({name, control, errors, question, options, label, placeholder, required}) {

  return (
      <FormControl fullWidth error={errors? true: false}>
        <FormLabel required={required}>{question}</FormLabel>
        <Controller
          name={name}
          control={control}
          defaultValue={[]}
          render={({ field: { onChange } }) => 
          <Autocomplete
              multiple
              required={required}
              options={options}
              getOptionLabel={(option) => option.name}
              onChange={(event, newValue) => onChange(newValue)}
              renderInput={(params) => (
              <TextField
                  {...params}
                  variant="standard"
                  label={label ? label : ""}
                  placeholder={placeholder ? placeholder : ""}
              />
              )}
          />
        }
      />
      <Typography className="font-14 error-message">
        {errors?.message}
      </Typography>
      </FormControl>
  );
}